import { number } from 'fp-ts';
import * as option from './option.js';
export const Eq = number.Eq;
export const Ord = number.Ord;
export const zero = 0;
export const one = 1;
export const succ = (a) => (a + 1);
export const pred = (a) => option.when(a > 0, () => (a - 1));
export const isNatD = (d) => d.name === 'Nat';
export const SumMonoid = {
    empty: zero,
    concat: (a, b) => (a + b),
};
export const ProductMonoid = {
    empty: one,
    concat: (a, b) => (a * b),
};
export const fromLiteral = (n) => n;
//# sourceMappingURL=nat.js.map